<template>
  <div class="shop-naming-rules-container">
    <h1 class="main-title">店铺命名规范</h1>

    <!-- 第一章 概述 -->
    <section class="section-block">
      <h2 class="sub-title">第一章 概述</h2>

      <div class="sub-article">
        <h3 class="article-title">1.1 目的及依据</h3>
        <p class="article-content">
          为了规范平台内店铺名称的申请、修改等行为，给商家及消费者提供更加优质的体验，根据国家现行法律、法规、规章、《电子商务开放平台店铺服务协议》，特制定《店铺类型规范》及《店铺命名规范》，旨在维护平台的生态秩序和氛围。
        </p>
      </div>

      <div class="sub-article">
        <h3 class="article-title">1.2 适用范围</h3>
        <p class="article-content">本规则适用于平台内所有商家。</p>
      </div>

      <div class="sub-article">
        <h3 class="article-title">1.3 效力级别</h3>
        <p class="article-content">
          特别规定与一般规定不一致的，适用特别规定；新的规定与旧的规定不一致的，适用新的规定。平台规则尚无规定的，根据法律规定或相关协议处理。
        </p>
      </div>
    </section>

    <!-- 第二章 命名规范 -->
    <section class="section-block">
      <h2 class="sub-title">第二章 命名规范</h2>
      <div class="table-wrapper">
        <table class="rules-table">
          <colgroup>
            <col class="col-type" />
            <col class="col-pattern" />
            <col class="col-notice" />
          </colgroup>
          <thead>
            <tr>
              <th>店铺类型</th>
              <th>命名形式</th>
              <th>注意事项</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="2" class="cell-center cell-bold">旗舰店</td>
              <td><strong>品牌名+官方旗舰店</strong></td>
              <td>限 自有品牌 或 独占授权的品牌</td>
            </tr>
            <tr>
              <td>
                <strong>品牌名+ 一级类目（可选）+旗舰店</strong> ；
                若经营多类目，则选择其中一个经营类目即可
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="cell-center cell-bold">专卖店</td>
              <td>
                <p class="text-para">
                  <strong>品牌名+企业商号+一级类目（可选）+专卖店</strong>
                  ，举例：韩后水之恋美容护肤专卖店；
                </p>
                <p class="text-para">
                  若经营多类目，则可选择其中一个经营类目即可；
                </p>
                <p class="text-para">
                  若企业商号与品牌名重复，可命名为：品牌名+企业商号（公司名称中其它任意字段）+一级类目（可选）+专卖店。
                </p>
              </td>
              <td>
                店铺名称不得使用“旗舰”、“官方”、“直营”、“官方认证”、“官方授权”、“特许经营”、“特约经销”或其他带有类似含义的内容
              </td>
            </tr>
            <tr>
              <td class="cell-center cell-bold">专营店</td>
              <td>
                <p class="text-para">
                  <strong>企业商号+一级类目（可选）+专营店</strong>
                  ，不得以“XX（品牌名）专营店”命名，举例：宝锐数码专营店
                </p>
                <p class="text-para">
                  若经营多类目，则可选择其中一个经营类目即可
                </p>
              </td>
              <td>
                店铺名称不得使用“旗舰”、“官方”、“直营”、“官方认证”、“官方授权”、“特许经营”、“特约经销”或其他带有类似含义的内容
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- 第三章 店铺命名和LOGO规范 -->
    <section class="section-block">
      <h2 class="sub-title">第三章 店铺命名和LOGO规范</h2>
      <div class="rule-clause-list">
        <div class="rule-clause">
          <span class="clause-num">3.1</span>
          官方旗舰店、旗舰店、专卖店、专营店不超过60个字符。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.2</span>
          店铺名称只支持中文、英文和数字，不得出现其它符号。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.3</span>
          店铺名称不得与已经开通的店铺名称重复，如两个店铺同时申请同一店铺名的，则依照申请在先原则审批开通店铺，未通过审批的店铺需更换其他店铺名重新提交申请。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.4</span>
          官方旗舰店、旗舰店、专营店、专卖店的店铺名称，一经提交不支持修改。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.5</span>
          店铺名称和LOGO中如出现品牌和人名，需提供相应授权。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.6</span>
          店铺LOGO中不得涉及人物/动漫人物的肖像，如确实需要用到知名人物/明星/动漫人物作为店铺LOGO，需提供肖像授权或动漫人物版权授权，其中肖像授权书要求参考《招商标准及入驻规范》。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.7</span>
          店铺LOGO不得使用资质，合同类图片。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.8</span>
          若店铺LOGO中出现“小店”字样，需与店铺名称一致。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.9</span>
          店铺名称和LOGO不得带有电话号码、电子邮箱、网址、二维码、即时通讯工具或其他联系信息（如第三方平台等其他联系方式）。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.10</span>
          店铺名称和LOGO中不得含有政治敏感因素，平台禁售产品。
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.11</span>
          <div>
            店铺名称和LOGO不得包含违法和消极影响信息，包含但不限于：
            <ul class="sub-bullet-list">
              <li>有损于国家、社会公共利益，或有损民族尊严；</li>
              <li>
                含有封建文化糟粕、有消极政治影响、违背少数民族习俗或带有民族歧视内容；
              </li>
              <li>
                可能对公众造成欺骗或者误解，或引起社会公众不良心理反应等情况；
              </li>
              <li>
                县级以上行政区划的地名或者公众知晓的外国国家（地区）名称/国际组织名称，但地名具有其他含义或已经注册为商标、公司名称的除外；
              </li>
              <li>
                政党名称、党政军机关名称、群众组织名称、社会团体名称及部队番号或国家领导人及老一辈革命家的名字；
              </li>
              <li>有不文明/格调低级/庸俗等不雅词汇；</li>
              <li>出现平台相关的敏感或标志性信息；</li>
              <li>其他法律行政法规规定禁止的。</li>
            </ul>
          </div>
        </div>
        <div class="rule-clause">
          <span class="clause-num">3.12</span>
          <div>
            店铺名称和LOGO不得包含容易造成消费者混淆的信息，包括但不限于：
            <ul class="sub-bullet-list">
              <li>包含知名人士姓名、地名的品牌；</li>
              <li>与知名品牌相同或近似的品牌；</li>
              <li>
                使用品牌的变形词或衍生词来描述商品的，包含但不限于错别字、拼音、特殊符号等；
              </li>
              <li>
                同第三方标志相同或者近似的，如：中国邮政、中石化、中石油等；
              </li>
              <li>
                未经平台或集团授权、许可使用的名称、标识或其他信息。如：
                包含“AZG官方”、“AZ全球购自营”及近似含义词语；“安心购”、“带货分”、“信用分”等代表特殊含义的词语或表示；
              </li>
              <li>AZG集团及旗下其他公司的名称或标识；</li>
              <li>
                使用促销相关名称，与特定资质或活动相关的特定含义的词语。如:满减、折扣、打折、满赠等；
              </li>
              <li>
                使用除经营范围之外的其他品类名称，如：商家经营类目不包含药品或医疗器械，店铺名称为XXX医疗健康专营店、XXX大药房；
              </li>
              <li>使用《广告法》禁止情形的名称；</li>
              <li>其他违反法律法规或平台禁止使用的信息。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 第四章 违规处理 -->
    <section class="section-block">
      <h2 class="sub-title">第四章 违规处理</h2>
      <div class="rule-clause-list">
        <div class="rule-clause">
          <span class="clause-num">4.1</span>
          <div>
            商家设置的店铺名称、店铺头像（logo）、店铺类型等应遵守本规则要求。若发生以下情形（包括但不限于），平台有权通知商家在指定期限内修改店铺名称、店铺头像（logo）、店铺类型直至符合要求；若商家在指定期限内未修改或修改后仍不符合要求的，平台有权根据平台规则修改该店铺名称、店铺头像（logo）、店铺类型，并有权采取店铺/账号命名重置、商品下架、禁止商品上架、店铺类型变更、限制账号功能、账号封禁、店铺屏蔽等处置措施。
            <ul class="sub-bullet-list">
              <li>
                发现店铺名称、店铺头像（logo）、店铺类型（包括但不限于违反本规则、平台协议、平台其他规则或相关法律法规之规定（下同）或者存在其他违规风险的。
              </li>
              <li>
                因相关法律法规、主管部门监管政策、平台协议或平台规则变化，店铺名称、店铺头像（logo）、店铺类型不符合新的要求的。
              </li>
            </ul>
          </div>
        </div>
        <div class="rule-clause">
          <span class="clause-num">4.2</span>
          如因店铺名称、店铺头像（logo）、店铺类型违规导致平台或任何第三方遭受损害的，平台及遭受损害的第三方有权要求商家承担相应的法律责任。
        </div>
        <div class="rule-clause">
          <span class="clause-num">4.3</span>
          对于沉寂店铺、停业整顿店铺、退店中店铺，为了不影响其他店铺正常命名，平台有权对其店铺/账号命名进行重置或店铺类型变更。
        </div>
        <div class="rule-clause">
          <span class="clause-num">4.4</span>
          为了防止对公众造成不利影响，平台也可基于判断进行适当调整，采取删除/修改相关信息、增加区别性内容、限缩类目范围（如：按照注册商标核定使用的商品或服务类别确定类目）等措施。
        </div>
      </div>
    </section>

    <!-- 第五章 附则 -->
    <section class="section-block">
      <h2 class="sub-title">第五章 附则</h2>
      <div class="rule-clause-list">
        <div class="rule-clause">
          <span class="clause-num">5.1</span>
          【生效时间】本规则于2023年8月28日首次生效。
        </div>
        <div class="rule-clause">
          <span class="clause-num">5.2</span>
          平台有权对本说明进行不定期修订，并根据法律法规的规定执行公示程序。若修订内容涉及交易规则的，则将根据法律法规规定另行执行征求意见程序，公示期结束后，本说明修订内容即告生效。若商家不同意修订后的规则的，可通过平台指引申请停止使用平台服务。
        </div>
        <div class="rule-clause">
          <span class="clause-num">5.3</span>
          平台商家的相关行为，发生在本规则生效之日或修订之日以前的，适用当时的规则。发生在本规则生效之日或修订之日以后的，适用本规则。
        </div>
      </div>
    </section>

    <!-- 附：店铺名中可用类目简称 -->
    <section class="section-block">
      <div class="appendix-header">
        <h2 class="sub-title">附：店铺名中可用类目简称</h2>
        <div class="search-box">
          <el-input
            v-model="searchKeyword"
            placeholder="搜索一级类目或简称..."
            prefix-icon="el-icon-search"
            size="small"
            clearable
          />
        </div>
      </div>

      <div class="table-wrapper">
        <table class="alias-table">
          <colgroup>
            <col class="col-alias-category" />
            <col class="col-alias-name" />
          </colgroup>
          <thead>
            <tr>
              <th>一级类目名称</th>
              <th>最新外化名称</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredList" :key="index">
              <td>{{ item.category }}</td>
              <td>{{ item.name }}</td>
            </tr>
            <tr v-if="filteredList.length === 0">
              <td colspan="2" class="cell-empty">未匹配到相关类目</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { categoryAliasList } from "./shopNamingData";

export default {
  name: "ShopNamingRules",
  data() {
    return {
      searchKeyword: "",
      categoryAliasList
    };
  },
  computed: {
    filteredList() {
      if (!this.searchKeyword.trim()) {
        return this.categoryAliasList;
      }
      const kw = this.searchKeyword.trim().toLowerCase();
      return this.categoryAliasList.filter(
        item =>
          item.category.toLowerCase().includes(kw) ||
          item.name.toLowerCase().includes(kw)
      );
    }
  }
};
</script>

<style lang="less" scoped>
.shop-naming-rules-container {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  padding: 40px 60px;
  background-color: #ffffff;
  color: #262626;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  text-align: left;

  .main-title {
    margin: 0 0 32px 0;
    font-size: 26px;
    font-weight: 700;
    color: #1f1f1f;
    line-height: 1.3;
  }

  .section-block {
    margin-bottom: 36px;

    .sub-title {
      margin: 0 0 16px 0;
      font-size: 18px;
      font-weight: 700;
      color: #1f1f1f;
      line-height: 1.4;
    }
  }

  .sub-article {
    margin-bottom: 16px;

    .article-title {
      margin: 0 0 8px 0;
      font-size: 15px;
      font-weight: 600;
      color: #262626;
    }

    .article-content {
      margin: 0;
      font-size: 14px;
      line-height: 1.8;
      color: #383838;
    }
  }

  .rule-clause-list {
    .rule-clause {
      display: flex;
      margin-bottom: 14px;
      font-size: 14px;
      line-height: 1.8;
      color: #262626;

      .clause-num {
        font-weight: 600;
        margin-right: 8px;
        flex-shrink: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .sub-bullet-list {
    margin: 8px 0 0 0;
    padding-left: 20px;

    li {
      margin-bottom: 6px;
      line-height: 1.7;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .table-wrapper {
    width: 100%;
    overflow-x: auto;
  }

  .rules-table {
    width: 100%;
    max-width: 860px;
    border-collapse: collapse;
    border: 1px solid #d9d9d9;
    margin-bottom: 16px;

    .col-type {
      width: 15%;
      min-width: 90px;
    }

    .col-pattern {
      width: 50%;
      min-width: 300px;
    }

    .col-notice {
      width: 35%;
      min-width: 240px;
    }

    th,
    td {
      border: 1px solid #d9d9d9;
      padding: 10px 14px;
      font-size: 13px;
      line-height: 1.6;
      color: #262626;
      vertical-align: middle;
    }

    thead th {
      background-color: #fafafa;
      font-weight: 600;
      text-align: left;
    }

    .cell-center {
      text-align: center;
    }

    .cell-bold {
      font-weight: 600;
    }

    .text-para {
      margin: 0 0 6px 0;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .appendix-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 600px;
    margin-bottom: 16px;

    .sub-title {
      margin-bottom: 0;
    }

    .search-box {
      width: 220px;
    }
  }

  .alias-table {
    width: 100%;
    max-width: 600px;
    border-collapse: collapse;
    border: 1px solid #d9d9d9;
    margin-bottom: 24px;

    .col-alias-category {
      width: 55%;
    }

    .col-alias-name {
      width: 45%;
    }

    th,
    td {
      border: 1px solid #d9d9d9;
      padding: 8px 12px;
      font-size: 13px;
      line-height: 1.6;
      color: #262626;
    }

    thead th {
      background-color: #fafafa;
      font-weight: 600;
      text-align: left;
    }

    .cell-empty {
      text-align: center;
      color: #8c8c8c;
      padding: 24px 0;
    }
  }
}

@media only screen and (max-width: 768px) {
  .shop-naming-rules-container {
    padding: 24px 16px;

    .main-title {
      font-size: 22px;
      margin-bottom: 20px;
    }

    .section-block {
      margin-bottom: 28px;

      .sub-title {
        font-size: 16px;
      }
    }

    .appendix-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;

      .search-box {
        width: 100%;
      }
    }
  }
}
</style>
